import { render, staticRenderFns } from "./BookingListArchivedPage.vue?vue&type=template&id=76fffafe&scoped=true&"
import script from "./BookingListArchivedPage.vue?vue&type=script&lang=js&"
export * from "./BookingListArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fffafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fffafe')) {
      api.createRecord('76fffafe', component.options)
    } else {
      api.reload('76fffafe', component.options)
    }
    module.hot.accept("./BookingListArchivedPage.vue?vue&type=template&id=76fffafe&scoped=true&", function () {
      api.rerender('76fffafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/BookingListArchivedPage.vue"
export default component.exports